import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateThreeEnhancedSection, TemplateThreePDFSectionWithSubsections } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeEducation } from "lib/redux/types";

export const Education = ({
  heading,
  educations,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  educations: ResumeEducation[];
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateThreePDFSectionWithSubsections heading={heading}>
      {educations.map(
        (
          { school, degree, startDate, endDate, gpa, descriptions = [] },
          idx
        ) => {
          // Hide school name if it is the same as the previous school
          const hideSchoolName =
            idx > 0 && school === educations[idx - 1].school;
          const showDescriptions = descriptions?.join() !== "";

          return (
            <View key={idx} style={{ ...styles.flexRow, gap: "9pt" }} wrap={false}>
              <View
                style={{
                  width: "21%",
                }}
              >
                <ResumePDFText>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <View
                style={{
                  ...styles.flexCol,
                  width: "79%",
                }}
              >
                {!hideSchoolName && (
                  <ResumePDFText bold={true}>{school}</ResumePDFText>
                )}
                <View
                  style={{
                    marginTop: hideSchoolName
                      ? "-" + spacing["1"]
                      : spacing["1.5"],
                  }}
                >
                  <ResumePDFText>{`${
                    gpa ? `${degree} - ${gpa}` : degree
                  }`}</ResumePDFText>
                </View>
                {showDescriptions && (
                  <View
                    style={{ ...styles.flexCol, marginTop: spacing["1.5"] }}
                  >
                    <ResumePDFDescription 
                      items={descriptions} 
                      enableHighlight={enableHighlight}
                      enableMistakeHighlight={enableMistakeHighlight}
                      section="education"
                      itemIndex={idx}
                    />
                  </View>
                )}
              </View>
            </View>
          );
        }
      )}
    </TemplateThreePDFSectionWithSubsections>
  );
};
